import axios from "axios";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000";

const axiosInstance = axios.create({
  baseURL: API,
  withCredentials: true,
});

/**
 * Exam + Marks Analytics — Owner
 * GET /exams/analytics?period=&year=&month=&academicYear=
 */
export const getExamMarksAnalytics = async (params = {}) => {
  const res = await axiosInstance.get("/exams/analytics", { params });
  return res.data;
};

/**
 * Exam + Marks Analytics — Portal
 * GET /exam-portal/analytics?period=&year=&month=&academicYear=
 */
export const getExamMarksAnalyticsPortal = async (params = {}) => {
  const res = await axiosInstance.get("/exam-portal/analytics", { params });
  return res.data;
};
